// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Styles for VerificationModal component
 */

.verification-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;
}

.verification-modal {
  background: #F0F0F0;
  border-radius: 20px;
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  position: relative;
}

.verification-modal-header {
  padding: 20px;
  border-bottom: 1px solid #6A6A6A;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.verification-modal-header h2 {
  margin: 0;
  font-family: 'Open Sans', sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: normal;
  color: #4A4A4A;
  text-align: center;
}

.verification-modal-close {
  background: #4A4A4A;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #FFFFFF;
  padding: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  position: absolute;
  right: 15px;
  top: 15px;
  line-height: 1;
}

.verification-modal-close:hover {
  background: #333333;
}

.verification-modal-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}

.verification-modal-footer {
  padding: 20px;
  border-top: none;
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}

/* Accept/Reject screen for incoming requests */
.verification-accept-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  text-align: center;
}

.verification-accept-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  margin-bottom: 20px;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);
}

.verification-accept-screen h3 {
  margin: 0 0 15px 0;
  font-size: 22px;
  color: #333;
}

.verification-accept-message {
  font-size: 16px;
  color: #666;
  margin: 0 0 10px 0;
}

.verification-accept-message strong {
  color: #333;
  font-weight: 600;
}

.verification-accept-description {
  font-size: 14px;
  color: #999;
  margin: 0 0 30px 0;
}

.verification-accept-actions {
  display: flex;
  gap: 12px;
  width: 100%;
  max-width: 300px;
}

.verification-accept-actions .btn {
  flex: 1;
  padding: 12px 24px;
  font-size: 15px;
}

/* Loading state */
.verification-loading,
.verification-ready,
.verification-verifying {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  text-align: center;
}

.verification-loading p,
.verification-ready p,
.verification-verifying p {
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: normal;
  color: #6A6A6A;
  text-align: center;
  margin: 0;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f0f0f0;
  border-top: 3px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* SAS Emoji Verification */
.verification-sas-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.verification-sas-instructions {
  margin-bottom: 30px;
  font-size: 16px;
  color: #666;
  text-align: center;
}

.verification-sas-emojis {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
  gap: 15px;
  width: 100%;
  max-width: 400px;
  margin-bottom: 30px;
}

.verification-sas-emoji {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 8px;
  transition: background-color 0.2s;
}

.verification-sas-emoji:hover {
  background: #e9ecef;
}

.verification-sas-emoji .emoji {
  font-size: 32px;
  margin-bottom: 5px;
}

.verification-sas-emoji .name {
  font-size: 12px;
  color: #666;
  text-align: center;
}

.verification-sas-actions {
  display: flex;
  gap: 10px;
}

/* QR Code Verification */
.verification-qr-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.verification-qr-instructions {
  margin-bottom: 20px;
  font-size: 16px;
  color: #666;
}

.verification-qr-code {
  margin-bottom: 20px;
}

.qr-placeholder {
  width: 256px;
  height: 256px;
  background: #f0f0f0;
  border: 2px solid #ddd;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #999;
  font-size: 14px;
}

.verification-qr-alternative {
  font-size: 14px;
  color: #666;
}

/* Scan QR */
.verification-scan-qr {
  text-align: center;
  padding: 40px 20px;
}

.verification-scan-qr input {
  margin-top: 20px;
  width: 100%;
  max-width: 300px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

/* Complete/Error/Cancel states */
.verification-complete,
.verification-cancelled,
.verification-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  text-align: center;
}

.verification-complete h3,
.verification-cancelled h3,
.verification-error h3 {
  margin: 0 0 10px 0;
  font-family: 'Open Sans', sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: normal;
  color: #4A4A4A;
}

.verification-complete p,
.verification-cancelled p,
.verification-error p {
  margin: 0;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: normal;
  color: #6A6A6A;
}

.success-icon {
  width: 60px;
  height: 60px;
  background: #28a745;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 30px;
  margin-bottom: 20px;
}

.warning-icon {
  font-size: 48px;
  margin-bottom: 20px;
}

.error-icon {
  font-size: 48px;
  margin-bottom: 20px;
}

.verification-error-message {
  background: #f8d7da;
  color: #721c24;
  padding: 10px 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}

/* Modal loading overlay */
.verification-modal-loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

/* Button styles */
.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-primary {
  background: #DE4858;
  color: #FFFFFF;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.36181640625em;
  padding: 12px 30px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(222, 72, 88, 0.3);
  border: none;
  min-width: 100px;
  height: 46px;
  transition: all 0.2s ease;
}

.btn-primary:hover:not(:disabled) {
  background: #C93D4D;
  transform: translateY(-1px);
}

.btn-primary:active:not(:disabled) {
  transform: translateY(0);
}

.btn-secondary {
  background: #DE4858 !important;
  color: #FFFFFF !important;
  font-family: 'Open Sans', sans-serif !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  line-height: normal !important;
  padding: 8px 20px !important;
  border-radius: 10px !important;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.5) !important;
  border: none !important;
}

.btn-secondary:hover:not(:disabled) {
  background: #C93D4D !important;
}

.btn-success {
  background: #28a745;
  color: white;
}

.btn-success:hover:not(:disabled) {
  background: #218838;
}

.btn-danger {
  background: #dc3545;
  color: white;
}

.btn-danger:hover:not(:disabled) {
  background: #c82333;
}

/* Dark theme support */
@media (prefers-color-scheme: dark) {
  .verification-modal {
    background: #1e1e1e;
    color: #e0e0e0;
  }

  .verification-modal-header {
    border-bottom-color: #333;
  }

  .verification-modal-header h2 {
    color: #e0e0e0;
  }

  .verification-modal-close {
    color: #999;
  }

  .verification-modal-close:hover {
    color: #fff;
  }

  .verification-modal-footer {
    border-top-color: #333;
  }

  .verification-accept-screen h3 {
    color: #e0e0e0;
  }

  .verification-accept-message {
    color: #b0b0b0;
  }

  .verification-accept-message strong {
    color: #fff;
  }

  .verification-accept-description {
    color: #888;
  }

  .verification-sas-emoji {
    background: #2a2a2a;
  }

  .verification-sas-emoji:hover {
    background: #333;
  }

  .qr-placeholder {
    background: #2a2a2a;
    border-color: #444;
    color: #666;
  }

  .verification-scan-qr input {
    background: #2a2a2a;
    border-color: #444;
    color: #e0e0e0;
  }

  .verification-error-message {
    background: #5a1e1e;
    color: #f8d7da;
  }

  .verification-modal-loading {
    background: rgba(30, 30, 30, 0.9);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/verification/VerificationModal.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;;;EAGE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;EAGE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iCAAiC;AACjC;;;EAGE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;EAGE,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;EAGE,SAAS;EACT,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,4CAA4C;EAC5C,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,+CAA+C;EAC/C,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,qDAAqD;EACrD,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,iCAAiC;EACnC;AACF","sourcesContent":["/**\n * Styles for VerificationModal component\n */\n\n.verification-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10001;\n}\n\n.verification-modal {\n  background: #F0F0F0;\n  border-radius: 20px;\n  max-width: 600px;\n  width: 90%;\n  max-height: 80vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  position: relative;\n}\n\n.verification-modal-header {\n  padding: 20px;\n  border-bottom: 1px solid #6A6A6A;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n.verification-modal-header h2 {\n  margin: 0;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: normal;\n  color: #4A4A4A;\n  text-align: center;\n}\n\n.verification-modal-close {\n  background: #4A4A4A;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  color: #FFFFFF;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n  position: absolute;\n  right: 15px;\n  top: 15px;\n  line-height: 1;\n}\n\n.verification-modal-close:hover {\n  background: #333333;\n}\n\n.verification-modal-content {\n  flex: 1;\n  padding: 20px;\n  overflow-y: auto;\n}\n\n.verification-modal-footer {\n  padding: 20px;\n  border-top: none;\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px;\n}\n\n/* Accept/Reject screen for incoming requests */\n.verification-accept-screen {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 40px 20px;\n  text-align: center;\n}\n\n.verification-accept-icon {\n  width: 80px;\n  height: 80px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 40px;\n  margin-bottom: 20px;\n  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);\n}\n\n.verification-accept-screen h3 {\n  margin: 0 0 15px 0;\n  font-size: 22px;\n  color: #333;\n}\n\n.verification-accept-message {\n  font-size: 16px;\n  color: #666;\n  margin: 0 0 10px 0;\n}\n\n.verification-accept-message strong {\n  color: #333;\n  font-weight: 600;\n}\n\n.verification-accept-description {\n  font-size: 14px;\n  color: #999;\n  margin: 0 0 30px 0;\n}\n\n.verification-accept-actions {\n  display: flex;\n  gap: 12px;\n  width: 100%;\n  max-width: 300px;\n}\n\n.verification-accept-actions .btn {\n  flex: 1;\n  padding: 12px 24px;\n  font-size: 15px;\n}\n\n/* Loading state */\n.verification-loading,\n.verification-ready,\n.verification-verifying {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 40px 20px;\n  text-align: center;\n}\n\n.verification-loading p,\n.verification-ready p,\n.verification-verifying p {\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: normal;\n  color: #6A6A6A;\n  text-align: center;\n  margin: 0;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #f0f0f0;\n  border-top: 3px solid #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* SAS Emoji Verification */\n.verification-sas-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.verification-sas-instructions {\n  margin-bottom: 30px;\n  font-size: 16px;\n  color: #666;\n  text-align: center;\n}\n\n.verification-sas-emojis {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));\n  gap: 15px;\n  width: 100%;\n  max-width: 400px;\n  margin-bottom: 30px;\n}\n\n.verification-sas-emoji {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 10px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  transition: background-color 0.2s;\n}\n\n.verification-sas-emoji:hover {\n  background: #e9ecef;\n}\n\n.verification-sas-emoji .emoji {\n  font-size: 32px;\n  margin-bottom: 5px;\n}\n\n.verification-sas-emoji .name {\n  font-size: 12px;\n  color: #666;\n  text-align: center;\n}\n\n.verification-sas-actions {\n  display: flex;\n  gap: 10px;\n}\n\n/* QR Code Verification */\n.verification-qr-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.verification-qr-instructions {\n  margin-bottom: 20px;\n  font-size: 16px;\n  color: #666;\n}\n\n.verification-qr-code {\n  margin-bottom: 20px;\n}\n\n.qr-placeholder {\n  width: 256px;\n  height: 256px;\n  background: #f0f0f0;\n  border: 2px solid #ddd;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  color: #999;\n  font-size: 14px;\n}\n\n.verification-qr-alternative {\n  font-size: 14px;\n  color: #666;\n}\n\n/* Scan QR */\n.verification-scan-qr {\n  text-align: center;\n  padding: 40px 20px;\n}\n\n.verification-scan-qr input {\n  margin-top: 20px;\n  width: 100%;\n  max-width: 300px;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n/* Complete/Error/Cancel states */\n.verification-complete,\n.verification-cancelled,\n.verification-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 40px 20px;\n  text-align: center;\n}\n\n.verification-complete h3,\n.verification-cancelled h3,\n.verification-error h3 {\n  margin: 0 0 10px 0;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: normal;\n  color: #4A4A4A;\n}\n\n.verification-complete p,\n.verification-cancelled p,\n.verification-error p {\n  margin: 0;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: normal;\n  color: #6A6A6A;\n}\n\n.success-icon {\n  width: 60px;\n  height: 60px;\n  background: #28a745;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 30px;\n  margin-bottom: 20px;\n}\n\n.warning-icon {\n  font-size: 48px;\n  margin-bottom: 20px;\n}\n\n.error-icon {\n  font-size: 48px;\n  margin-bottom: 20px;\n}\n\n.verification-error-message {\n  background: #f8d7da;\n  color: #721c24;\n  padding: 10px 15px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n\n/* Modal loading overlay */\n.verification-modal-loading {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n}\n\n/* Button styles */\n.btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background: #DE4858;\n  color: #FFFFFF;\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 1.36181640625em;\n  padding: 12px 30px;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(222, 72, 88, 0.3);\n  border: none;\n  min-width: 100px;\n  height: 46px;\n  transition: all 0.2s ease;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: #C93D4D;\n  transform: translateY(-1px);\n}\n\n.btn-primary:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.btn-secondary {\n  background: #DE4858 !important;\n  color: #FFFFFF !important;\n  font-family: 'Open Sans', sans-serif !important;\n  font-weight: 600 !important;\n  font-size: 16px !important;\n  line-height: normal !important;\n  padding: 8px 20px !important;\n  border-radius: 10px !important;\n  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.5) !important;\n  border: none !important;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: #C93D4D !important;\n}\n\n.btn-success {\n  background: #28a745;\n  color: white;\n}\n\n.btn-success:hover:not(:disabled) {\n  background: #218838;\n}\n\n.btn-danger {\n  background: #dc3545;\n  color: white;\n}\n\n.btn-danger:hover:not(:disabled) {\n  background: #c82333;\n}\n\n/* Dark theme support */\n@media (prefers-color-scheme: dark) {\n  .verification-modal {\n    background: #1e1e1e;\n    color: #e0e0e0;\n  }\n\n  .verification-modal-header {\n    border-bottom-color: #333;\n  }\n\n  .verification-modal-header h2 {\n    color: #e0e0e0;\n  }\n\n  .verification-modal-close {\n    color: #999;\n  }\n\n  .verification-modal-close:hover {\n    color: #fff;\n  }\n\n  .verification-modal-footer {\n    border-top-color: #333;\n  }\n\n  .verification-accept-screen h3 {\n    color: #e0e0e0;\n  }\n\n  .verification-accept-message {\n    color: #b0b0b0;\n  }\n\n  .verification-accept-message strong {\n    color: #fff;\n  }\n\n  .verification-accept-description {\n    color: #888;\n  }\n\n  .verification-sas-emoji {\n    background: #2a2a2a;\n  }\n\n  .verification-sas-emoji:hover {\n    background: #333;\n  }\n\n  .qr-placeholder {\n    background: #2a2a2a;\n    border-color: #444;\n    color: #666;\n  }\n\n  .verification-scan-qr input {\n    background: #2a2a2a;\n    border-color: #444;\n    color: #e0e0e0;\n  }\n\n  .verification-error-message {\n    background: #5a1e1e;\n    color: #f8d7da;\n  }\n\n  .verification-modal-loading {\n    background: rgba(30, 30, 30, 0.9);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
